/** Retry a photo's legacy fallback URL once when the CDN thumbnail fails. */
export const onImgError = (e, photo) => {
  if (photo.fallback && e.target.src !== photo.fallback) e.target.src = photo.fallback;
};
